import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/services/toast.service';
import { BudgetService } from '../service/budget.service';

@Component({
  selector: 'apc-budget-filler',
  templateUrl: './budget-filler.component.html',
  styleUrls: ['./budget-filler.component.scss'],
  providers: [BudgetService],
})
export class BudgetFillerComponent implements OnInit {
  @Input() modalRef: any;
  @Input() budgetId: string;
  @Input() orderId: string;
  public products: any;
  public data;
  public forms: UntypedFormArray = new UntypedFormArray([]);
  public notAvailableForms: UntypedFormArray = new UntypedFormArray([]);

  public form: UntypedFormGroup;
  public oldForm: UntypedFormArray = new UntypedFormArray([]);
  public totalProgress: number = 0;
  public totalProgressSelected: number;
  public oldTotalProgress: number;
  public ignoreMouseOut: boolean = false;
  public mouseIn: boolean = false;
  public saveDisabled: boolean = true;
  public showModal: boolean = false;
  constructor(private budgetService: BudgetService, private toastService: ToastService) {}

  ngOnInit(): void {
    //#692, timeout because -> expression has changed after it was checked
    setTimeout(() => {
      this.budgetService.getBudgetProductsQuantity(this.orderId, this.budgetId).then(
        (res) => {
          this.showModal = true;
          this.products = res;
          if (this.products.availableModels.length > 0) {
            this.products.availableModels.forEach((el) => {
              this.forms.push(this.initForm(el));
            });
          }
          if (this.products.notAvailableModels.length > 0) {
            this.products.notAvailableModels.forEach((el) => {
              this.notAvailableForms.push(this.initForm(el));
            });
          }
        },
        (err) => this.close(null)
      );
    }, 0);
  }

  initForm(data) {
    this.form = new UntypedFormGroup({
      identifier: new UntypedFormControl(data?.identifier),
      code: new UntypedFormControl({ value: data?.code, disabled: true }),
      name: new UntypedFormControl({ value: data?.name, disabled: true }),
      quantity: new UntypedFormControl(0, [Validators.required]),
      available: new UntypedFormControl({ value: data?.available, disabled: true }),
      startingHours: new UntypedFormControl({ value: data.startingHours ? Number(data.startingHours) : 0, disabled: true }),
      progressColor: new UntypedFormControl({ value: 'grey', disabled: true }),
      backgroundProgressColor: new UntypedFormControl({
        value: Number(data.available) == 0 ? 'grey' : 'green',
        disabled: true,
      }),
      progressClasses: new UntypedFormControl({ value: this.calcProgressClasses(data), disabled: true }),
    });
    return this.form;
  }

  calcProgressClasses(data) {
    if (Number(data.available) === 0) {
      return 'form-control quantity-input quantity-input-grey autogenerated';
    }
    return 'form-control quantity-input';
  }

  close(budget: any) {
    this.modalRef.dismiss(budget);
  }

  parseNum(num) {
    return Number(num);
  }

  save() {
    this.forms.value.forEach((val) => {
      val.quantity = Number(val.quantity);
    });
    this.budgetService.updateBudgetProductQuantity(this.budgetId, this.forms.value).then(
      (res) => {
        this.toastService.showSuccess('Operation success!');
        this.close(res);
      },
      (error) => {
        console.log(error)
        this.toastService.showError('Operation error!');
      }
    );
  }

  calcProgress(form) {
    return Number(form.controls.quantity.value / form.controls.available.value) * 100;
  }

  calcTotalProgress(val: number, isHover: boolean = false) {
    this.ignoreMouseOut = true;
    if (this.forms.controls.length) {
      this.forms.controls.forEach((control: any) => {
        control.controls.quantity.patchValue((val * Number(control.controls.available.value)).toFixed(2));
        this.progressColorCalc(control);
      });
    }
  }

  progressColorCalc(form) {
    if (Number(form.controls.quantity.value) == 0) {
      this.saveDisabled = true;
      form.controls.progressColor.patchValue('grey');
      if (Number(form.controls.available.value) == 0) {
        form.controls.backgroundProgressColor.patchValue('grey');
      } else if (Number(form.controls.quantity.value) < Number(form.controls.available.value)) {
        form.controls.backgroundProgressColor.patchValue('green');
      }
    } else {
      if (Number(form.controls.quantity.value) > Number(form.controls.available.value)) {
        form.controls.progressColor.patchValue('red');
      } else if (Number(form.controls.quantity.value) <= Number(form.controls.available.value)) {
        form.controls.progressColor.patchValue('#488aff');
        form.controls.backgroundProgressColor.patchValue('green');
      }
    }
    this.checkSaveDisabled();
  }

  setTempValues(val: number) {
    localStorage.setItem('oldBudgetFill', JSON.stringify(this.forms.value));
    this.mouseIn = true;
    this.totalProgress = Number(val) * 100;
    this.calcTotalProgress(val, true);
    this.ignoreMouseOut = false;
    this.saveDisabled = true;
  }
  returnOldValues() {
    this.mouseIn = false;
    if (!this.ignoreMouseOut) {
      this.forms.patchValue(JSON.parse(localStorage.getItem('oldBudgetFill')));
      localStorage.removeItem('oldBudgetFill');
      if (this.forms.controls.length) {
        this.forms.controls.forEach((control: any) => {
          this.progressColorCalc(control);
        });
      }
      this.mouseIn = false;
      this.ignoreMouseOut = false;
    }
    this.totalProgress = 0;
  }

  checkSaveDisabled() {
    this.forms.controls.forEach((control: any) => {
      if (Number(control.controls.quantity.value) > 0) {
        this.saveDisabled = false;
      }
    });
  }
}
